<!-- Page banner Area -->
<div class="page-banner bg-9">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-content service-banner-content">
                    <h2>Contact Us</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Contact</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page banner Area -->

<!-- Main Contact Section -->
<div class="contact-main-wrapper p-5">
    <div class="container">
        <div class="row g-4 justify-content-center">

            <div class="w-full">
                <div class="card border-0 shadow-lg rounded-4 overflow-hidden bg-white">
                    <div class="card-header bg-white border-bottom p-4">
                        <div class="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-2">
                            <div>
                                <h4 class="fw-bold text-dark mb-1"><i
                                        class="fas fa-paper-plane text-primary me-2"></i>Submit Support Request</h4>
                                <p class="text-muted small mb-0">Fill out the fields below. Tracking number verification
                                    is required.</p>
                            </div>
                            <span
                                class="badge bg-light text-muted border rounded-pill px-3 py-1.5 font-monospace extra-small">
                                <i class="fas fa-lock text-success me-1"></i> Encrypted Session
                            </span>
                        </div>
                    </div>

                    <div class="card-body p-4 p-md-5">

                        <!-- Success Banner -->
                        <div *ngIf="formSuccessMsg"
                            class="alert alert-success border-0 rounded-3 p-3.5 mb-4 shadow-xs d-flex align-items-center gap-3">
                            <div
                                class="bg-success text-white rounded-circle p-2 d-flex align-items-center justify-content-center">
                                <i class="fas fa-check-circle fa-lg"></i>
                            </div>
                            <div>
                                <h6 class="fw-bold mb-0">Message Sent Successfully!</h6>
                                <div class="small">{{ formSuccessMsg }}</div>
                            </div>
                        </div>

                        <!-- Error Banner -->
                        <div *ngIf="formErrorMsg"
                            class="alert alert-danger border-0 rounded-3 p-3.5 mb-4 shadow-xs d-flex align-items-center gap-3">
                            <div
                                class="bg-danger text-white rounded-circle p-2 d-flex align-items-center justify-content-center">
                                <i class="fas fa-exclamation-triangle fa-lg"></i>
                            </div>
                            <div>
                                <h6 class="fw-bold mb-0">Submission Failed</h6>
                                <div class="small">{{ formErrorMsg }}</div>
                            </div>
                        </div>

                        <!-- Contact Form -->
                        <form [formGroup]="contactFormGroup" (ngSubmit)="submitForm()">
                            <div class="row g-3.5">

                                <!-- Name -->
                                <div class="col-12 col-md-4">
                                    <label for="contact_name"
                                        class="form-label small fw-bold text-dark text-uppercase mb-1.5">
                                        Your Full Name <span class="text-danger">*</span>
                                    </label>
                                    <div class="input-group">
                                        <span class="input-group-text bg-light border-end-0 text-muted rounded-start-3">
                                            <i class="fas fa-user"></i>
                                        </span>
                                        <input type="text" id="contact_name" formControlName="name"
                                            class="form-control rounded-end-3" placeholder="e.g. Alex Morgan">
                                    </div>
                                    <div *ngIf="contactFormGroup.get('name').invalid && (contactFormGroup.get('name').touched || isSubmit)"
                                        class="text-danger extra-small mt-1">
                                        <i class="fas fa-exclamation-circle me-1"></i> Name is required.
                                    </div>
                                </div>

                                <!-- Email -->
                                <div class="col-12 col-md-4">
                                    <label for="contact_email"
                                        class="form-label small fw-bold text-dark text-uppercase mb-1.5">
                                        Email Address <span class="text-danger">*</span>
                                    </label>
                                    <div class="input-group">
                                        <span class="input-group-text bg-light border-end-0 text-muted rounded-start-3">
                                            <i class="fas fa-envelope"></i>
                                        </span>
                                        <input type="email" id="contact_email" formControlName="email"
                                            class="form-control rounded-end-3" placeholder="e.g. alex@example.com">
                                    </div>
                                    <div *ngIf="contactFormGroup.get('email').invalid && (contactFormGroup.get('email').touched || isSubmit)"
                                        class="text-danger extra-small mt-1">
                                        <span *ngIf="contactFormGroup.get('email').hasError('required')"><i
                                                class="fas fa-exclamation-circle me-1"></i> Email is required.</span>
                                        <span *ngIf="contactFormGroup.get('email').hasError('email')"><i
                                                class="fas fa-exclamation-circle me-1"></i> Please enter a valid
                                            email.</span>
                                    </div>
                                </div>

                                <!-- Tracking Number with Live Validation Button & Status Badge -->
                                <div class="col-12 col-md-4">
                                    <label for="contact_tracking"
                                        class="form-label small fw-bold text-dark text-uppercase mb-1.5">
                                        <span>Tracking Number <span class="text-danger">*</span></span>
                                        <span *ngIf="trackingValidated"
                                            class="badge bg-success-subtle text-success rounded-pill px-2.5 py-0.5 font-monospace">
                                            <i class="fas fa-check-circle me-1"></i> Tracking Verified
                                        </span>
                                    </label>
                                    <div class="input-group">
                                        <span class="input-group-text bg-light border-end-0 text-muted rounded-start-3">
                                            <i class="fas fa-barcode"></i>
                                        </span>
                                        <input type="text" id="contact_tracking" formControlName="tracking_number"
                                            class="form-control font-monospace" [class.is-valid]="trackingValidated"
                                            [class.is-invalid]="trackingValidationError"
                                            placeholder="e.g. 9719109177 or ORD-10023">
                                    </div>

                                    <!-- Tracking Status Badges & Messages -->
                                    <div *ngIf="trackingVerifiedMsg"
                                        class="text-success extra-small mt-1.5 fw-semibold d-flex align-items-center">
                                        <i class="fas fa-check-circle me-1"></i> {{ trackingVerifiedMsg }}
                                    </div>
                                    <div *ngIf="trackingValidationError"
                                        class="text-danger extra-small mt-1.5 fw-semibold d-flex align-items-center">
                                        <i class="fas fa-times-circle me-1"></i> {{ trackingValidationError }}
                                    </div>
                                    <div *ngIf="contactFormGroup.get('tracking_number').invalid && (contactFormGroup.get('tracking_number').touched || isSubmit) && !trackingValidationError"
                                        class="text-danger extra-small mt-1">
                                        <i class="fas fa-exclamation-circle me-1"></i> Tracking number is required for
                                        support.
                                    </div>
                                </div>

                                <!-- Subject -->
                                <div class="col-12 col-md-6">
                                    <label for="contact_subject"
                                        class="form-label small fw-bold text-dark text-uppercase mb-1.5">
                                        Subject / Topic <span class="text-danger">*</span>
                                    </label>
                                    <div class="input-group">
                                        <span class="input-group-text bg-light border-end-0 text-muted rounded-start-3">
                                            <i class="fas fa-tag"></i>
                                        </span>
                                        <input type="text" id="contact_subject" formControlName="subject"
                                            class="form-control rounded-end-3"
                                            placeholder="e.g. Package Delivery Delay">
                                    </div>
                                    <div *ngIf="contactFormGroup.get('subject').invalid && (contactFormGroup.get('subject').touched || isSubmit)"
                                        class="text-danger extra-small mt-1">
                                        <i class="fas fa-exclamation-circle me-1"></i> Subject is required.
                                    </div>
                                </div>

                                <!-- Phone Number (Optional) -->
                                <div class="col-12 col-md-6">
                                    <label for="contact_phone"
                                        class="form-label small fw-bold text-dark text-uppercase mb-1.5">
                                        Phone Number <span class="text-muted fw-normal">(Optional)</span>
                                    </label>
                                    <div class="input-group">
                                        <span class="input-group-text bg-light border-end-0 text-muted rounded-start-3">
                                            <i class="fas fa-phone"></i>
                                        </span>
                                        <input type="number" id="contact_phone" formControlName="phone_number"
                                            class="form-control rounded-end-3" placeholder="e.g. +1 555 0199">
                                    </div>
                                </div>

                                <!-- Message -->
                                <div class="col-12">
                                    <label for="contact_message"
                                        class="form-label small fw-bold text-dark text-uppercase mb-1.5">
                                        Detailed Support Message <span class="text-danger">*</span>
                                    </label>
                                    <textarea id="contact_message" formControlName="message"
                                        class="form-control rounded-3" rows="5"
                                        placeholder="Please describe your issue or inquiry in detail..."></textarea>
                                    <div *ngIf="contactFormGroup.get('message').invalid && (contactFormGroup.get('message').touched || isSubmit)"
                                        class="text-danger extra-small mt-1">
                                        <i class="fas fa-exclamation-circle me-1"></i> Message details are required.
                                    </div>
                                </div>

                                <!-- Submit Action -->
                                <div class="col-12 pt-2">
                                    <button type="submit"
                                        class="btn btn-primary btn-lg rounded-pill shadow-sm w-100 fw-bold py-3 transition-all"
                                        [disabled]="btnDisable || isLoading">
                                        <span *ngIf="!isLoading">
                                            Send Support Message <i class="fas fa-paper-plane ms-2"></i>
                                        </span>
                                        <span *ngIf="isLoading">
                                            <i class="fas fa-circle-notch fa-spin me-2"></i> Submitting Request...
                                        </span>
                                    </button>
                                </div>

                            </div>
                        </form>

                    </div>
                </div>
            </div>

        </div>
    </div>
</div>